__webpack_require__.p = "/cloud-kitchen/";